import type { AppSummary } from "../../shared/schemas";

export function AppGlyph({ icon }: Pick<AppSummary, "icon">) {
  const className =
    "size-6 fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] [stroke-width:1.7]";

  if (icon === "quotes") {
    return (
      <svg aria-hidden="true" className={className} data-app-glyph={icon} viewBox="0 0 24 24">
        <path d="M7 7.5h10M7 11.5h7M7 15.5h5" />
        <path d="M5 3.5h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2Z" />
      </svg>
    );
  }
  if (icon === "parts") {
    return (
      <svg aria-hidden="true" className={className} data-app-glyph={icon} viewBox="0 0 24 24">
        <path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Z" />
        <path d="m4.4 7.7 7.6 4.2 7.6-4.2M12 12v9" />
      </svg>
    );
  }
  if (icon === "files") {
    return (
      <svg aria-hidden="true" className={className} data-app-glyph={icon} viewBox="0 0 24 24">
        <path d="M3.5 7.5v10a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-8h-9l-2-2h-6Z" />
        <path d="M7.5 13h9M7.5 16h6" />
      </svg>
    );
  }
  if (icon === "listener") {
    return (
      <svg aria-hidden="true" className={className} data-app-glyph={icon} viewBox="0 0 24 24">
        <path d="M4 5.5h16v13H4zM4 9h16" />
        <path d="m7.5 12 2.5 2-2.5 2M12.5 16h4" />
      </svg>
    );
  }
  return (
    <svg aria-hidden="true" className={className} data-app-glyph={icon} viewBox="0 0 24 24">
      <path d="M4 5.5h16v13H4zM4 10h16M9 10v8.5" />
    </svg>
  );
}
